import { z } from 'zod';

export const validator = z.object({
    email: z
        .string({
            required_error: 'Email address is required',
        })
        .email('Invalid email address'),
});

export type FormShape = z.infer<typeof validator>;
